import { render, staticRenderFns } from "./CreateCintilloPage.vue?vue&type=template&id=12a92339"
import script from "./CreateCintilloPage.vue?vue&type=script&lang=js"
export * from "./CreateCintilloPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports